var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2174 16.7994C15.3542 16.7994 14.6527 16.0979 14.6527 15.2347V12.6374C14.6527 11.7742 15.3542 11.0727 16.2174 11.0727H20.2929C20.3173 11.0727 20.3418 11.0727 20.3662 11.0746V8.48677C20.3662 7.82101 19.8265 7.28125 19.1607 7.28125H4.20552C3.53976 7.28125 3 7.82101 3 8.48677V19.3853C3 20.0511 3.53976 20.5908 4.20552 20.5908H19.1607C19.8265 20.5908 20.3662 20.0511 20.3662 19.3853V16.7975C20.3418 16.7994 20.3173 16.7994 20.2929 16.7994H16.2174Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2929 11.9304H16.2175C15.8263 11.9304 15.5103 12.2464 15.5103 12.6376V15.2348C15.5103 15.626 15.8263 15.9419 16.2175 15.9419H20.2929C20.6841 15.9419 21 15.626 21 15.2348V12.6376C21 12.2464 20.6841 11.9304 20.2929 11.9304ZM17.6223 14.9564C17.0581 14.9564 16.6011 14.4994 16.6011 13.9352C16.6011 13.371 17.0581 12.914 17.6223 12.914C18.1865 12.914 18.6435 13.371 18.6435 13.9352C18.6435 14.4994 18.1865 14.9564 17.6223 14.9564Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.06 5.06968C16.791 4.25346 15.909 3.80962 15.0928 4.07856L8.96552 6.10405H17.4023L17.06 5.06968Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/Deposit.2c6c7a57103b13656f3b96738b7a6faa.svg";
export { ForwardRef as ReactComponent };